import React from "react";
import injuredIcon from "assets/products/shared/icons/injured.svg";
import fallingIcon from "assets/products/shared/icons/falling.svg";
import calendarIcon from "assets/products/shared/icons/calendar.svg";

interface AccidentsAreCommonAndCostlyProps {
    className?: string;
}

const AccidentsAreCommonAndCostly = ({ className = "" }: AccidentsAreCommonAndCostlyProps) => {
    const statistics = [
        {
            icon: <img src={injuredIcon} alt="Injured icon" className="tablet:w-9 tablet:h-9 w-6 h-6" />,
            text: "Over 40% of injured patients report difficulty paying medical bills, often resulting in delayed care.",
            ref: "⁴",
        },
        {
            icon: <img src={fallingIcon} alt="Falling icon" className="tablet:w-9 tablet:h-9 w-6 h-6" />,
            text: "Over 26 million Americans visited emergency rooms for unintentional injuries in 2022.",
            ref: "⁵",
        },
        {
            icon: <img src={calendarIcon} alt="Calendar icon" className="tablet:w-9 tablet:h-9 w-6 h-6" />,
            text:
                "More people under the age of 44 died from accidental injury in 2023 than cancer, suicide, homicide, heart disease and liver \n" +
                "disease combined.",
            ref: "⁶",
        },
    ];

    return (
        <div className={`w-full py-6 tablet:py-12 bg-neutral px-6 ${className}`}>
            <div className="max-w-[1200px] max-h-max mx-auto">
                <div className="flex flex-col lg:flex-row tablet:gap-12 gap-4 items-center justify-between">
                    <div className="space-y-4 max-w-md">
                        <h2 className="text-base-content text-3xl tablet:text-5xl font-semibold tablet:font-normal open-sans text-left">
                            Accidents are common - and costly
                        </h2>
                        <div className="space-y-2">
                            <p className="text-base-content font-medium leading-5 text-sm">
                                A sudden injury or loss of life can leave families struggling to cover daily expenses. Emergency
                                services, recovery, time off work and covering final expenses can lead to significant financial
                                strain. Member Loyalty<sup>®</sup> Accident Insurance can alleviate this strain by covering some
                                of those costs.
                            </p>
                        </div>
                    </div>
                    <div className="flex justify-end">
                        <div className="space-y-2 max-w-md">
                            {statistics.map((stat) => (
                                <div key={stat.text} className="flex items-center space-x-6 text-base">
                                    <p className="flex-shrink-0">{stat.icon}</p>
                                    <p className="text-base-content font-medium leading-6 font-sans text-base">
                                        {stat.text}
                                        <a href="#disclosures" className="text-primary hover:underline">
                                            <span className="text-blue-600">{stat.ref}</span>
                                        </a>
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccidentsAreCommonAndCostly;
